import useSWR from 'swr';
import { CURRENT_ENV } from '../../constants';
import metadata from '../../metadata.json';
const env = import.meta.env.VITE_API_ENV || CURRENT_ENV;

const unauthenticatedFetcher = async (path) => {
  const basePath = metadata.environments[env].apiUrl;
  const url = `${basePath}${path}`;
  const res = await fetch(url);

  if (res.status === 404) {
    return undefined;
  }

  if (!res.ok) {
    throw new Error();
  }

  return res.json();
};

export default function useBmsVersion() {
  return useSWR<BMSLabellingInfo>(`/bms/version/admin/${metadata.version}`, unauthenticatedFetcher);
}
